module.exports = __webpack_public_path__ + "static/compost-ae86c4074f7cf6030cfd6fb9e83dc48e.jpg";